import { render, staticRenderFns } from "./AutomationAttributeTiptap.vue?vue&type=template&id=e0405d74&scoped=true"
import script from "./AutomationAttributeTiptap.vue?vue&type=script&lang=js"
export * from "./AutomationAttributeTiptap.vue?vue&type=script&lang=js"
import style0 from "./AutomationAttributeTiptap.vue?vue&type=style&index=0&id=e0405d74&prod&scoped=true&lang=scss"
import style1 from "./AutomationAttributeTiptap.vue?vue&type=style&index=1&id=e0405d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0405d74",
  null
  
)

export default component.exports